<template>
  <social-sharing :url="shareUrl()"
                  :quote="shareQoute()"
                  :title="shareTitle()"
                  :description="shareDescription()"
                  :hashtags="hashtags()"
                  twitter-user="vuejs"
                  inline-template>
    <div>
      <network network="email">
        <icon :icon="['fad', 'envelope']"/>
        Email
      </network>
      <network network="facebook" class="ml-2">
        <icon :icon="['fab', 'facebook']"/>
        Facebook
      </network>
      <network network="linkedin" class="ml-2">
        <icon :icon="['fab', 'linkedin']"/>
        LinkedIn
      </network>
      <network network="pinterest" class="ml-2">
        <icon :icon="['fab', 'pinterest']"/>
        Pinterest
      </network>
      <network network="skype" class="ml-2">
        <icon :icon="['fab', 'skype']"/>
        Skype
      </network>
      <network network="sms" class="ml-2">
        <icon :icon="['fad', 'sms']"/>
        SMS
      </network>
      <network network="telegram" class="ml-2">
        <icon :icon="['fab', 'telegram']"/>
        Telegram
      </network>
      <network network="twitter" class="ml-2">
        <icon :icon="['fab', 'twitter']"/>
        Twitter
      </network>
      <network network="whatsapp" class="ml-2">
        <icon :icon="['fab', 'whatsapp']"/>
        Whatsapp
      </network>
    </div>
  </social-sharing>
</template>
<script>
    export default {
        name: 'UserShare',
        props: [
            'poster', 'title'
        ],
        methods: {
            hashtags() {
                return process.env.VUE_APP_CONGRESS_DB + ', eposter'
            },
            shareDescription() {
                return 'Check out this ePoster I found at ' + process.env.VUE_APP_TITLE + '.';
            },
            shareTitle() {
                return process.env.VUE_APP_TITLE
            },
            shareUrl() {
                return process.env.VUE_APP_PATH_DOCURL + '#/viewer/' + this.poster;
            },
            shareQoute() {
                return '"' + this.title + '"';
            },
        }
    }
</script>
<style scoped>
  @media (min-width: 10em) {
  }

</style>
